<div class="outer-container">

    <lib-breadcrumbs class="breadcrumbs" [crumbsStr]="crumbsStr">
    </lib-breadcrumbs>

    <div class="buttons-container">
        <ng-content></ng-content>
    </div>
</div>
